import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import { Button } from '@nextiva/next-ui';

import styles from './ErrorBoundary.scss';

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div className={styles.errorBlock}>
          <p>We&apos;re sorry — something&apos;s gone wrong.</p>
          <p>Our team has been notified</p>
          <br />
          <Button onClick={() => Sentry.showReportDialog()}>
            Report feedback
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
